import { render } from "./ScoutTable.vue?vue&type=template&id=b4c5fee0"
import script from "./ScoutTable.vue?vue&type=script&lang=js"
export * from "./ScoutTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__